/*
En este fichero se importan, se cargan y se configura todos los componentes
genéricos a utilizar dentro de la web de cifra
*/
import AsignacionOptativasView from '../matriculas/AsignacionOptativasView.vue';
import BotonGuardar from '../inputs/BotonGuardar.vue';
import CondicionesView from '../condiciones/CondicionesView.vue';
import ContenedorDestinatarios from '../mensajes/ContenedorDestinatarios.vue';
import Dropzone from '../Dropzone.vue';
import EstructuraEscolar from '../EstructuraEscolar.vue';
import IconoBoolean from '../IconoBoolean.vue';
import IconoSeleccionable from './iconos/IconoSeleccionable.vue';
import IconosRadios from './iconos/IconosRadios.vue';
import IndicadoresAlumno from '../alumnos/Indicadores.vue';
import InputBase from './InputBase.vue';
import InputCheckboxBoolean from './InputCheckboxBoolean.vue';
import InputColor from '../inputs/InputColor.vue';
import InputDiasSemana from './InputDiasSemana.vue';
import InputFechaHora from './InputFechaHora.vue';
import InputIbanBic from '../inputs/InputIbanBic.vue';
import InputNumerico from '../inputs/InputNumerico.vue';
import InputParentesco from './InputParentesco.vue';
import InputPrecioPorcentaje from '../inputs/InputPrecioPorcentaje.vue';
import InputRadio from './InputRadio.vue';
import ItemsDiariosEstadisticasAlumno from '../items_diarios/EstadisticasAlumno.vue';
import ItemsDiariosView from '../items_diarios/ItemsDiariosView.vue';
import SelectorServicioCurso from '../servicios/SelectorServicioCurso.vue';
import InputTags from '../inputs/InputTags.vue';
import DesplazadorFecha from './DesplazadorFecha.vue';
import EditorFormula from '../formulas/EditorFormula.vue';
import Patologias from '../alumnos/Patologias.vue';
import SelectCifra from '../inputs/SelectCifra.vue';
import SelectCifraInput from '../inputs/SelectCifraInput.vue';
import SelectCifraAjax from '../inputs/SelectCifraAjax.vue';
import SelectorGrupos from '../grupos/SelectorGrupos.vue';
import SelectorImagen from './SelectorImagen.vue';
import SelectorImagenForm from './SelectorImagenForm.vue';
import SelectorNumerico from '../inputs/SelectorNumerico.vue';
import SeleccionAlumnosView from '../alumnos/SeleccionAlumnosView.vue';
import SelectorUsuario from './SelectorUsuario.vue';
import InputUsuario from './InputUsuario.vue';
import Spinner from '../Spinner.vue';
import Calendario from './Calendario.vue';
import PopoverCifra from './PopoverCifra.vue';
import LabelUsuarioPopover from '../usuarios/LabelUsuarioPopover.vue';
import InputCsrf from '../inputs/InputCsrf.vue';
import CifraInputField from '../inputs/CifraInputField.vue';
import Select2 from '../inputs/Select2.vue';
import SelectorParentesco from './SelectorParentesco.vue';
import ThumbnailHeader from './ThumbnailHeader.vue';
import ConfirmLink from './ConfirmLink.vue';
import BotonItemsPublicos from '../calificaciones/BotonItemsPublicos.vue';
import TreeItem from './TreeItem.vue';

export default {
  install: (app, _options) => {
    app
      .component('AsignacionOptativasView', AsignacionOptativasView)
      .component('BotonGuardar', BotonGuardar)
      .component('CondicionesView', CondicionesView)
      .component('ContenedorDestinatarios', ContenedorDestinatarios)
      .component('Dropzone', Dropzone)
      .component('EstructuraEscolar', EstructuraEscolar)
      .component('IconoBoolean', IconoBoolean)
      .component('IconoSeleccionable', IconoSeleccionable)
      .component('IconosRadios', IconosRadios)
      .component('IndicadoresAlumno', IndicadoresAlumno)
      .component('InputCsrf', InputCsrf)
      .component('InputBase', InputBase)
      .component('InputCheckboxBoolean', InputCheckboxBoolean)
      .component('InputDiasSemana', InputDiasSemana)
      .component('InputFechaHora', InputFechaHora)
      .component('InputIbanBic', InputIbanBic)
      .component('InputNumerico', InputNumerico)
      .component('InputColor', InputColor)
      .component('InputParentesco', InputParentesco)
      .component('InputPrecioPorcentaje', InputPrecioPorcentaje)
      .component('InputRadio', InputRadio)
      .component('InputTags', InputTags)
      .component('ItemsDiariosView', ItemsDiariosView)
      .component('ItemsDiariosEstadisticasAlumno', ItemsDiariosEstadisticasAlumno)
      .component('DesplazadorFecha', DesplazadorFecha)
      .component('EditorFormula', EditorFormula)
      .component('CifraInputField', CifraInputField)
      .component('Patologias', Patologias)
      .component('SeleccionAlumnosView', SeleccionAlumnosView)
      .component('SelectCifra', SelectCifra)
      .component('SelectCifraInput', SelectCifraInput)
      .component('SelectCifraAjax', SelectCifraAjax)
      .component('SelectorGrupos', SelectorGrupos)
      .component('SelectorImagen', SelectorImagen)
      .component('SelectorImagenForm', SelectorImagenForm)
      .component('SelectorNumerico', SelectorNumerico)
      .component('SelectorServicioCurso', SelectorServicioCurso)
      .component('SelectorUsuario', SelectorUsuario)
      .component('Select2', Select2)
      .component('SelectorParentesco', SelectorParentesco)
      .component('Spinner', Spinner)
      .component('Calendario', Calendario)
      .component('PopoverCifra', PopoverCifra)
      .component('LabelUsuarioPopover', LabelUsuarioPopover)
      .component('ConfirmLink', ConfirmLink)
      .component('ThumbnailHeader', ThumbnailHeader)
      .component('InputUsuario', InputUsuario)
      .component('BotonItemsPublicos', BotonItemsPublicos)
      .component('TreeItem', TreeItem);
  },
};
